/**
 * 画像遅延読み込みディレクティブ
 * 画像の遅延読み込みを実装するVueディレクティブ
 */
// src/directives/lazy-load.js

/**
 * 画像遅延読み込みディレクティブ
 * v-lazy ディレクティブとして使用
 */
export const lazyLoad = {
  bind(el, binding) {
    // 初期状態ではプレースホルダー画像を表示
    el.src = binding.value.placeholder || '/static/images/placeholder.png';
    el.classList.add('lazy-image');
    
    // 遅延読み込みの設定
    const options = {
      root: null, // ビューポートをルートとして使用
      rootMargin: '50px', // 50px手前から読み込み開始
      threshold: 0.1 // 10%表示されたら読み込み開始
    };
    
    // Intersection Observerを作成
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 画像が表示範囲に入ったら実際の画像を読み込み
          loadImage(entry.target, binding.value);
          observer.unobserve(entry.target);
        }
      });
    }, options);
    
    // 要素を監視開始
    observer.observe(el);
    
    // 要素にobserverを保存（後でクリーンアップ用）
    el._lazyObserver = observer;
  },
  
  unbind(el) {
    // クリーンアップ
    if (el._lazyObserver) {
      el._lazyObserver.disconnect();
      delete el._lazyObserver;
    }
  }
};

/**
 * 画像を読み込む関数
 * @param {HTMLElement} img - 画像要素
 * @param {Object} options - オプション
 */
function loadImage(img, options) {
  const { src, error, loading } = options;
  
  // ローディング状態を表示
  if (loading) {
    img.classList.add('lazy-loading');
  }
  
  // 新しい画像オブジェクトを作成してプリロード
  const imageLoader = new Image();
  
  imageLoader.onload = () => {
    // 読み込み成功
    img.src = src;
    img.classList.remove('lazy-loading');
    img.classList.add('lazy-loaded');
    
    // フェードイン効果
    img.style.opacity = '0';
    img.style.transition = 'opacity 0.3s ease-in-out';
    
    requestAnimationFrame(() => {
      img.style.opacity = '1';
    });
  };
  
  imageLoader.onerror = () => {
    // 読み込み失敗
    img.src = error || '/static/images/error.png';
    img.classList.remove('lazy-loading');
    img.classList.add('lazy-error');
    
    console.warn('画像の読み込みに失敗しました:', src);
  };
  
  // 画像の読み込み開始
  imageLoader.src = src;
}

/**
 * 遅延読み込み用のCSSクラス
 */
export const lazyLoadStyles = `
.lazy-image {
  opacity: 0.3;
  transition: opacity 0.3s ease-in-out;
  background: #f5f5f5;
  background-image: linear-gradient(45deg, #f0f0f0 25%, transparent 25%), 
                    linear-gradient(-45deg, #f0f0f0 25%, transparent 25%), 
                    linear-gradient(45deg, transparent 75%, #f0f0f0 75%), 
                    linear-gradient(-45deg, transparent 75%, #f0f0f0 75%);
  background-size: 20px 20px;
  background-position: 0 0, 0 10px, 10px -10px, -10px 0px;
}

.lazy-loading {
  opacity: 0.5;
  background: #e6f7ff;
}

.lazy-loaded {
  opacity: 1;
  background: none;
}

.lazy-error {
  opacity: 0.8;
  background: #fff2f0;
  border: 1px solid #ffccc7;
}
`;

export default lazyLoad;



// WEBPACK FOOTER //
// ./src/directives/lazy-load.js